import { render, staticRenderFns } from "./iFrame.vue?vue&type=template&id=6b1957c2"
import script from "./iFrame.vue?vue&type=script&lang=js"
export * from "./iFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports